import React from 'react';
import type { EPRItem } from '../../types/eprFramework';

/**
 * EPRComponentSection — wraps a list of EPRItem cards under a component
 * header (OKR / KPI / Core / Leadership) with weight and progress hint.
 */

const COMPONENT_META: Record<
  EPRItem['component'],
  { label: string; icon: string }
> = {
  okr:        { label: 'OKR',                    icon: 'track_changes' },
  kpi:        { label: 'KPI',                    icon: 'speed' },
  core:       { label: 'Core Competencies',      icon: 'groups' },
  leadership: { label: 'Leadership Skills',      icon: 'stars' },
};

export interface EPRComponentSectionProps {
  component: EPRItem['component'];
  weight: number;            // 0..1
  filledCount: number;
  totalCount: number;
  children: React.ReactNode;
}

const EPRComponentSection: React.FC<EPRComponentSectionProps> = ({
  component, weight, filledCount, totalCount, children,
}) => {
  const meta = COMPONENT_META[component];
  const pct  = Math.round(weight * 100);

  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <span
            className="material-symbols-rounded text-stone-500"
            style={{ fontSize: 22 }}
            aria-hidden="true"
          >
            {meta.icon}
          </span>
          <h2 className="text-lg font-semibold text-stone-900">
            {meta.label}
            <span className="ml-2 text-sm font-normal text-stone-500">({pct}%)</span>
          </h2>
        </div>
        <div className="text-xs text-stone-500 shrink-0">
          {filledCount}/{totalCount} filled
        </div>
      </div>
      <div className="space-y-3">{children}</div>
    </section>
  );
};

export default EPRComponentSection;
